import { CardContent } from '@mui/material';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import React from 'react';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink } from '../../ui-elements/MyMLink';
import SalesLv1MetadataCard from './SalesLv1MetadataCard';

export const SalesLv1SalesProductsCard = ({ borderSolid, navigateSalesLv2, screenId, lblHeader, imgFileName, lblModels, salesProduct, modelGroupColumnCount }) => {


  // 2024.5.8 MyMine Version1.5対応 Add Start
  // 表示するModelGroupの列数
  let modelGroupIndex = 0;
  // 2024.5.8 MyMine Version1.5対応 Add End

  return (
    <SalesLv1MetadataCard>
      <CardMedia sx={{ height: '140px', }} image={`${process.env.PUBLIC_URL}/${screenId}/${imgFileName}`} />
      <CardHeader className='py-0 text-center' sx={{ height: '35px', }} title={lblHeader} />
      <CardContent className='py-1 d-flex flex-column' sx={{ borderTop: borderSolid, height: 'calc(100% - 140px - 35px)' }}>
        <MyMLabel className='fw-bold pb-2'>{lblModels}</MyMLabel>
        <Grid container>
          {
            // 2024.5.8 MyMine Version1.5対応 Modify Start
            // 列数の倍数となる配列を作成
            [...Array(Math.ceil(salesProduct.ModelGroupList.length / modelGroupColumnCount) * modelGroupColumnCount)]
              .map((_, columnIndex) => {
                const modelGroup = salesProduct.ModelGroupList[modelGroupIndex];
                // PositionOrderが未設定 又は PositionOrderが特定の位置の場合、ModelGroupを表示
                if (modelGroup?.OrderNo === columnIndex + 1) {
                  modelGroupIndex++;
                  return modelGroup;
                } else {
                  return null;
                }
              })
              .map((modelGroup, i) =>
                <Grid item key={i} xs={12 / modelGroupColumnCount} className='pb-2'>
                  {modelGroup &&
                    <>
                      <MyMLabel className='fw-bolder' fontSize='1rem'>{modelGroup.GroupName}</MyMLabel>
                      <Grid container sx={{ display: 'flex', flexDirection: 'column' }}>
                        {modelGroup.ModelList.map((model, modelindex) => {
                          return (
                            <Grid item className='py-1' key={modelindex} >
                              <MyMBlackLink className='text-start' onClick={() => navigateSalesLv2(model)}>{model.Name}</MyMBlackLink>
                            </Grid>
                          )
                        })}
                      </Grid>
                    </>
                  }
                </Grid>
              )
            // 2024.5.8 MyMine Version1.5対応 Modify End
          }
        </Grid>
      </CardContent>
    </SalesLv1MetadataCard>
  )
}
